import { useTheme } from "@emotion/react";
import React from "react";
import { Chart } from "react-google-charts";


export const MyPieChart = (dataset) => {
  const theme=useTheme();
  const data = [
    [`${dataset.mydata.name}`, "Percent"],
    [`${dataset.mydata.option1}`, dataset.mydata.value1],
    [`${dataset.mydata.option2}`, dataset.mydata.value2],
  ];
  
  const options = {
    title: `${dataset.mydata.name}`,
    pieHole: 0.4,
    slices: {
      0: { color: `${theme.palette.primary.main}` },
      1: { color: `${theme.palette.secondary.main}` }
    },
    chartArea:{
      width:'90%',
      height:'75%'
    }
  };
  return(
    <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width="100%"
      height="132px"
    />
  );
}

export const MyPieChart2 = (dataset) => {
  const theme=useTheme();
  const data = [
    [`${dataset.mydata.name}`, "Percent"],
    [`${dataset.mydata.option1}`, dataset.mydata.value1],
    [`${dataset.mydata.option2}`, dataset.mydata.value2],
    [`${dataset.mydata.option3}`, dataset.mydata.value3],
  ];
  
  const options = {
    title: `${dataset.mydata.name}`,
    pieHole: 0.4,
    slices: {
      0: { color: `${theme.palette.primary.main}` },
      1: { color: `${theme.palette.secondary.main}` },
      2: { color: `${theme.palette.primary.light}` }
    },
    chartArea:{
      width:'90%',
      height:'75%'
    }
  };
  return(
    <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width="100%"
      height="132px"
    />
  );
}


export const MyBarChart = (dataset) => {
  const theme=useTheme();
  // let options = {
  //   width: 'auto',
  //   height: 152,
  //   // bar: {groupWidth: "95%"},
  // };
  const data = [
    ...[["Staff", "Load", { role: "style" }]],
    ...dataset.mydata.map((data, index) => [``, data, `${theme.palette.primary.main}`]),
  ]
  return (
    <Chart 
      chartType="ColumnChart"   
      width="100%"  
      height="332px" 
      data={data} 
      // options={options} 
    />
  );
}

// export const MyBarChart = (dataset) => {
//     const data = [
//         [
//           `${dataset.mydata.name}`,
//           "Percent",
//           { role: "style" },
//           {
//             sourceColumn: 0,
//             role: "annotation",
//             type: "string",
//             calc: "stringify",
//           },
//         ],
//         [`${dataset.mydata.option1}`, dataset.mydata.value1, `${theme.palette.primary.main}`, null],
//         [`${dataset.mydata.option2}`, dataset.mydata.value2, `${theme.palette.secondary.light}`, null],
//     ];
//     const options = {
//         // title: "Staff Load",
//         width: 'auto',
//         height: '80',
//         bar: { groupWidth: "50%" },
//         legend: { position: "none" },
//         hAxis: {
//             minValue: 0,
//             maxValue: 100
//         },
//         vAxis: {
//             textStyle: {
//                 // fontSize: 8
//             }
//         }
//     };
//   return (
//     <Chart
//       chartType="BarChart"
//       width="100%"
//       height="auto"
//       data={data}
//       options={options}
//       minValue={0}
//     />
//   );
// }
